import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-bulk-add-validation-dialog',
  templateUrl: './bulk-add-validation-dialog.component.html',
  styleUrls: ['./bulk-add-validation-dialog.component.scss']
})
export class BulkAddValidationDialogComponent implements OnInit {
  tags: any;

  constructor(private matDialogRef: MatDialogRef<any>) { }

  ngOnInit() {
    this.tags = this.matDialogRef.componentInstance.tags;
  }
}
